import sdkSessionUtil from 'bam-browser-sdk-sdkSession-util';
import SDK from 'bam-browser-sdk';

export async function initializeSdk(cb) {
    const { server_path } = window;

    sdkSessionUtil.setBootstrapConfiguration(server_path.sdk);

    try {
        const session = await sdkSessionUtil.getSdkSession();
        const info = await session.getSessionInfo();
        const UserActivity = {
            GlimpseEvents: SDK.UserActivity.Glimpse.GlimpseEvents,
            GlimpseEvent: SDK.UserActivity.Glimpse.GlimpseEvent,
            UserActivityApi: session.userActivityApi
        };

        if (typeof(cb) === 'function') {
            cb({
                UserActivity,
                sessionInfo: info
            });
        }
    } catch (err) {
        console.error(err);
    }
}
